import { DayHeaderProps } from '@msc-b2c/interfaces/types';
import { Icon, Text } from '@msc-b2c/shared-components';
import styles from '../dayTabs.module.scss';

const DayHeader: React.FC<DayHeaderProps> = ({
  id,
  tabId,
  dayPreTitle,
  portName,
  icon,
  departureInfo,
}) => {
  return (
    <div
      id={id}
      role="tabpanel"
      aria-labelledby={tabId}
      tabIndex={0}
      className={styles.dayHeaderContainer}
    >
      {dayPreTitle && (
        <Text
          styleOption={styles.dayPreTitle}
          text={dayPreTitle}
          tagHtml="p"
        />
      )}
      {portName && (
        <Text
          styleOption={styles.portName}
          text={portName}
          tagHtml="p"
        />
      )}
      {icon && departureInfo && (
        <div className={styles.dayHeaderInfo}>
          <Icon icon={icon} />
          <Text
            styleOption={styles.departureInfo}
            text={departureInfo}
            tagHtml="p"
          />
        </div>
      )}
    </div>
  );
};

export default DayHeader;
